import { ChangeDetectorRef, Component, Input, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core'
import { IlsModelService } from '../../../../shared/services/ils-model.service'
import { FileShowingComponent } from '../file-showing-component'
import { DomSanitizer } from '@angular/platform-browser'
import { AutoResizeElementService } from '@monorepo/angular-common'
import { Content } from '@monorepo/golab-generated'

@Component({
  selector: 'app-image-content',
  templateUrl: './image-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-content.component.scss'],
})
export class ImageContentComponent extends FileShowingComponent implements OnDestroy {
  private readonly ilsModelService = inject(IlsModelService);

  sizeAvailable = false
  width = 0
  height = 0
  private contentScale = 1
  private autoResizeElementService: AutoResizeElementService

  constructor() {
    const sanitizer = inject(DomSanitizer);
    const changeDetectorRef = inject(ChangeDetectorRef);

    super(sanitizer)
    const ilsModelService = this.ilsModelService;

    this.autoResizeElementService = new AutoResizeElementService(ilsModelService, (size) => {
      // console.log('newSize$', size)
      setTimeout(() => {
        this.width = size.width
        this.height = size.height
        changeDetectorRef.detectChanges()
      })
    })
  }

  @Input() set content(content: Content | undefined) {
    if (content) {
      this.setImageProperties(content)
      this.autoResizeElementService.setReferenceId(content._id)
    }
  }

  ngOnDestroy() {
    // this.autoResizeElementService.destroy()
  }

  protected override updateUrl(url: string): string {
    if (this.contentScale < 1) {
      return url.replace('/images/get-image/', '/scaled-images/get-image/' + this.contentScale + '/')
    } else {
      return url
    }
  }

  private setImageProperties(content: Content): void {
    this.contentScale = content.scale ?? 1
    this.setUrl(content)
    const contentWidth = content.width ?? 0
    const contentHeight = content.height ?? 0
    this.sizeAvailable = contentWidth > 0 && contentHeight > 0
    const desiredWidth = contentWidth * this.contentScale
    const desiredHeight = contentHeight * this.contentScale
    this.width = desiredWidth
    this.height = desiredHeight
    this.autoResizeElementService.setDesiredSize(desiredWidth, desiredHeight)
    this.autoResizeElementService.setAutoResize(this.sizeAvailable)
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(_event: any) {
  //   this.autoResizeElementService.onResize()
  // }
}
